import styled from "styled-components";

export const StyledFooter = styled.footer`
  width: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${props => props.bgColor};
  padding: 10px 0;
`;
export const Copyright = styled.div`
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px 0;
  color: #9da0ae;
  font-size: 0.875rem;
  line-break: 1.2rem;
`;

export const Text = styled.p``;

export const SocialContainer = styled.div`
  width: 100px;
  display: flex;
  justify-content: space-between;
`;

export const Icon = styled.img`
  width: ${({ width }) => (width ? `${width}px` : "auto")};
  height: ${({ height }) => (height ? `${height}px` : "auto")};
`;

export const Span = styled.span`
  width: 20px;
  height: 20px;
  background-color: #151875;
  padding: 3px;
  border-radius: 50%;
`;

export const FooterContent = styled.div`
  display: grid;
  width: 100%;
  gap: 40px;

  grid-template-columns: repeat(9, 1fr);

  @media (max-width: 1023px) {
    grid-template-columns: 1fr 1fr;
    gap: 30px 80px;
    & > * {
      grid-column: unset;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Logo = styled.a`
  font-size: 2.125rem;
  line-height: 1;
  font-weight: 700;
  font-family: "Josefin Sans", sans-serif;
  color: #0d0e43;
  display: inline-block;
  margin: 10px 0;
`;

export const Contact = styled.div`
  grid-column: 1/4;
  @media (max-width: 768px) {
    grid-column: unset;
  }
`;

export const InputBox = styled.div`
  width: 320px;
  height: 40px;
  position: relative;
  margin: 14px 0 20px;

  @media (max-width: 425px) {
    width: 100%;
  }
`;
export const Box = styled.div`
  background-color: #fb2e86;
  padding: 15px;
  width: 135px;
  height: 40px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #fff;
  border-radius: 3px;
  font-size: 12px;
`;

export const Input = styled.input`
  height: 100%;
  width: 100%;
  padding-left: 20px;
  opacity: 0.45;
  border: none;
  outline: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 3px;
  font-size: 12px;
`;

export const Paragraph = styled.p`
  font-size: 13px;
  line-height: 1.5;

  color: #8a8fb9;
`;
